import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGovernment: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGovernment"><Path fillRule="evenodd" clipRule="evenodd" d="M15 3H12.75V4.0332C16.6963 4.35885 19.9184 7.2287 20.7744 11H22V12.5H20.9854C20.9944 12.6655 21 12.8322 21 13V19.5H22V21H2V19.5H3V13C3 12.8322 3.00558 12.6655 3.01465 12.5H2V11H3.22559C4.08159 7.2287 7.30369 4.35885 11.25 4.0332V0H15V3ZM4.51855 12.5C4.50767 12.6653 4.5 12.8319 4.5 13V19.5H8.5V12.5H4.51855ZM10 12.5V19.5H14V12.5H10ZM15.5 12.5V19.5H19.5V13C19.5 12.8319 19.4923 12.6653 19.4814 12.5H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGovernment;
